(function () {
  'use strict';

  /* @ngdoc object
   * @name tracking
   * @description
   *
   */
  angular
    .module('tracking', [
      'ui.router'
    ]);
}());
